angular.module('common.directives').directive('reportDashboard', function () {
  return {
    scope: {
      edge: '=',
      eventSearch: '='
    },
    templateUrl: './templates/reportDashboard.view.html?t=' + webpackHash,
    link: function ($scope, $element, attrs) {},
    controller: 'reportsDashboardController'
  }
})
